<template>
  <w-sliding-popup ref="slidingPopup" title="장애 조치 추천" width="950px" @close="close">
    <div slot="content">
      <w-event-hist-select-component v-show="!hiddenSelectCmp" :class="hiddenSelectCmp ? null : 'mr-b10'" :event-hist-seq-numbers="eventHistSeqNumbers" :is-predict-event="isPredictEvent" @select="setEventHistData" @reset="reset" />
      <hr v-show="!hiddenSelectCmp" :class="hiddenSelectCmp ? null : 'mr-b25'" />
      <div class="mr-b20">
        <el-row class="title-bar mr-t10" type="flex" justify="space-between">
          <div class="title-h4">대상 이벤트 정보</div>
        </el-row>
        <el-row class="list form-list">
          <el-col :span="12" class="pd-r20">
            <el-form label-position="left">
              <el-form-item label="대상" label-width="120px">{{targetEventInfo.objName}}</el-form-item>
              <el-form-item label="관리 구분" label-width="120px">{{targetEventInfo.managetypeName}}</el-form-item>
              <el-form-item label="자원" label-width="120px">{{targetEventInfo.rscName}}</el-form-item>
              <el-form-item label="장애 메시지" label-width="120px">{{targetEventInfo.eventMessage}}</el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form size="mini" label-position="left">
              <el-form-item v-if="!isPredictEvent" label="최초 발생시각" label-width="120px">{{ getDateFormatter(null, null, targetEventInfo.checkDatetime)}}</el-form-item>
              <el-form-item v-else label="예측 발생시각" label-width="120px">{{ getDateFormatter(null, null, targetEventInfo.checkDatetime)}}</el-form-item>
              <el-form-item label="자원구분" label-width="120px">{{targetEventInfo.rsctypeName}}</el-form-item>
              <el-form-item label="등급" label-width="120px">{{targetEventInfo.eventlevelName}}</el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="mr-b20" v-loading="isLoading">
        <el-row class="title-bar mr-b10" type="flex" justify="space-between">
          <div class="title-h4">장애 조치 추천</div>
        </el-row>
        <el-row class="mr-b20" style="padding: 17px 25px; background: #f7f8fa; border-top: 2px solid #e2e5ec;">
          <w-search-field ref="searchField" @search="searchTroubleHandlingInfo"></w-search-field>
        </el-row>
        <w-recommend-handling-trouble-view :target-event-info="targetEventInfo" :searchkeyword="searchkeyword" @change-load-mask="changeLoadMask" ref="recommendHandlingTroubleView"/>
      </div>
    </div>
  </w-sliding-popup>
</template>

<script>
import WSearchField from '@/components/form/SearchField';
import { isNil, isEmpty } from 'lodash';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import WRecommendHandlingTroubleButton from '@/views/event/components/RecommendHandlingTroubleButton';
import WEventHistSelectComponent from '@/components/popup/EventSmartAnalyzerPopup/components/EventHistSelectComponent';
import WRecommendHandlingTroubleView from '@/components/popup/FaultAnalysisPopup/components/RecommendHandlingTroubleView';

export default {
  name: 'WRecommendHandlingTroublePopup',
  components: {
    WSearchField,
    WRecommendHandlingTroubleButton,
    WEventHistSelectComponent,
    WRecommendHandlingTroubleView,
  },
  props: {
    eventHistSeqNumbers: Array,
    isPredictEvent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchkeyword: '',
      isLoading: false,
      targetEventInfo: {
        // objName: null,
        // managetypeName: null,
        // managetypeId: null,
        // rscName: null,
        // rscId: null,
        // rscKey: null,
        // eventlevelId: null,
        // eventMessage: null,
        // checkDatetime: null,
        // rsctypeName: null,
        // rsctypeId: null,
        // eventlevelName: null,
      },
    };
  },
  computed: {
    /**
     * 이벤트 선택 컴포넌트 숨기기 여부
     * @author Ju
     * @return {Boolean} true: 숨김 / false: 제공
     */
    hiddenSelectCmp() {
      return isEmpty(this.eventHistSeqNumbers) || this.eventHistSeqNumbers.length === 1;
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
    },
    close() {
      this.$refs.searchField.clear();
      this.$refs.recommendHandlingTroubleView.clear();
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    searchTroubleHandlingInfo(keyword) {
      this.searchkeyword = keyword;
      this.$nextTick(() => {
        this.$refs.recommendHandlingTroubleView.loadData();
      });
    },
    reset() {
      // this.eventHistData = {};
    },
    setEventHistData(eventHistData) {
      this.targetEventInfo = eventHistData;
    },
    changeLoadMask(isLoading) {
      this.isLoading = isLoading;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/components/popup/RecommendHandlingTroublePopup.vue